import { useMutation, useQueryClient } from '@tanstack/react-query';
import { commitBulkMatch, previewBulkMatch } from '../../../../services/epcDayPlanTemplateService';
import type { BulkMatchCommitBody } from '../types';

export function usePreviewBulkMatch(projectId: string) {
    return useMutation({
        mutationFn: (importId?: string) => previewBulkMatch(projectId, importId),
    });
}

export function useCommitBulkMatch(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body: BulkMatchCommitBody) => commitBulkMatch(projectId, body),
        onSuccess: () => {
            // New mappings feed Plan Builder pickers, the drift list, day plans
            // and the project header.
            qc.invalidateQueries({ queryKey: ['epc-dm', 'template-mapping', projectId] });
            qc.invalidateQueries({ queryKey: ['epc', 'template-mappings', projectId] });
            qc.invalidateQueries({ queryKey: ['epc-dm', 'day-plan', projectId] });
            qc.invalidateQueries({ queryKey: ['epc-project', projectId] });
        },
    });
}
